export default {
    instructionsField: {
        minHeight: 70
    }
};
